(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="custom-reels-"]').forEach(function (root) {
      if (root.dataset.crInit === '1') return;
      root.dataset.crInit = '1';

      var cards = Array.from(root.querySelectorAll('[data-reel-card]'));
      if (!cards.length) return;

      var dialog = root.querySelector('[data-reel-dialog]');
      var player = dialog.querySelector('[data-reel-player]');
      var playerWrap = dialog.querySelector('[data-reel-player-wrap]');
      var playPauseBtn = dialog.querySelector('[data-reel-playpause]');
      var closeBtn = dialog.querySelector('[data-reel-close]');
      var prevBtn = dialog.querySelector('[data-reel-prev]');
      var nextBtn = dialog.querySelector('[data-reel-next]');
      var muteBtn = dialog.querySelector('[data-reel-mute]');
      var muteOn = dialog.querySelector('[data-reel-mute-on]');
      var muteOff = dialog.querySelector('[data-reel-mute-off]');
      var productCard = dialog.querySelector('[data-reel-product-card]');
      var productImage = dialog.querySelector('[data-reel-product-image]');
      var productTitle = dialog.querySelector('[data-reel-product-title]');
      var productPrice = dialog.querySelector('[data-reel-product-price]');

      var currentIndex = 0;

      function loadReel(index) {
        if (index < 0) index = cards.length - 1;
        if (index >= cards.length) index = 0;
        currentIndex = index;
        var card = cards[index];
        player.src = card.dataset.reelVideo || '';
        player.currentTime = 0;
        var p = player.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            player.muted = true;
            player.play();
            updateMuteIcon();
          });
        }

        var pUrl = card.dataset.reelProductUrl;
        var pTitle = card.dataset.reelProductTitle;
        var pPrice = card.dataset.reelProductPrice;
        var pImage = card.dataset.reelProductImage;

        if (pUrl) {
          productCard.href = pUrl;
          productTitle.textContent = pTitle || '';
          productPrice.textContent = pPrice || '';
          if (pImage) {
            productImage.src = pImage;
            productImage.style.display = '';
          } else {
            productImage.style.display = 'none';
          }
          productCard.classList.remove('is-hidden');
        } else {
          productCard.classList.add('is-hidden');
        }
      }

      function openAtIndex(index) {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.body.style.overflow = 'hidden';
        loadReel(index);
      }

      function closeDialog() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.body.style.overflow = '';
        player.pause();
        player.removeAttribute('src');
        player.load();
      }

      function updateMuteIcon() {
        if (player.muted) {
          if (muteOn) muteOn.classList.add('is-hidden');
          if (muteOff) muteOff.classList.remove('is-hidden');
        } else {
          if (muteOn) muteOn.classList.remove('is-hidden');
          if (muteOff) muteOff.classList.add('is-hidden');
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          openAtIndex(parseInt(card.dataset.reelIndex, 10) || 0);
        });

        var gridVideo = card.querySelector('.custom-reels__video');
        if (gridVideo && root.dataset.autoplayGrid === 'true') {
          card.addEventListener('mouseenter', function () { gridVideo.play().catch(function () {}); });
          card.addEventListener('mouseleave', function () { gridVideo.pause(); gridVideo.currentTime = 0; });
        }
      });

      var track = root.querySelector('[data-reel-track]');
      var trackPrev = root.querySelector('[data-reel-track-prev]');
      var trackNext = root.querySelector('[data-reel-track-next]');

      function scrollByCard(direction) {
        if (!track) return;
        var firstCard = track.querySelector('.custom-reels__card');
        var step = firstCard ? firstCard.getBoundingClientRect().width + parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10) : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      if (trackPrev) trackPrev.addEventListener('click', function () { scrollByCard(-1); });
      if (trackNext) trackNext.addEventListener('click', function () { scrollByCard(1); });

      function updateTrackNavState() {
        if (!track || (!trackPrev && !trackNext)) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (trackPrev) trackPrev.hidden = track.scrollLeft <= 0;
        if (trackNext) trackNext.hidden = track.scrollLeft >= maxScroll;
      }

      if (track) {
        track.addEventListener('scroll', updateTrackNavState, { passive: true });
        window.addEventListener('resize', updateTrackNavState);
        updateTrackNavState();
      }

      if (closeBtn) closeBtn.addEventListener('click', closeDialog);
      if (prevBtn) prevBtn.addEventListener('click', function () { loadReel(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { loadReel(currentIndex + 1); });

      if (muteBtn) {
        muteBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          player.muted = !player.muted;
          updateMuteIcon();
        });
      }

      function updatePlayPauseIcon() {
        if (!playPauseBtn) return;
        if (player.paused) playPauseBtn.classList.remove('is-hidden');
        else playPauseBtn.classList.add('is-hidden');
      }

      if (playerWrap) {
        playerWrap.addEventListener('click', function (event) {
          if (event.target.closest('[data-reel-mute]') || event.target.closest('[data-reel-playpause]')) return;
          if (player.paused) player.play().catch(function () {});
          else player.pause();
        });
      }

      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          player.play().catch(function () {});
        });
      }

      player.addEventListener('play', updatePlayPauseIcon);
      player.addEventListener('pause', updatePlayPauseIcon);

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', function () {
        document.body.style.overflow = '';
        player.pause();
      });

      if (root.dataset.autoplayGrid === 'true' && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('.custom-reels__video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 });
        cards.forEach(function (card) { observer.observe(card); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
